<template>
    <div class="container">
        <!--工具条-->
        <el-form :inline="true" class="demo-form-inline" style="margin-top: 10px;padding: 0px">
            <el-form-item style="margin-left: 5px">
                <el-button type="primary" @click="newdrugs"><i class="el-icon-plus"></i>新增药品</el-button>
            </el-form-item>
            <div style="float:right">
                <el-form-item label='药品名:' class="distanceLeft">
                    <el-input placeholder="请输入搜索内容" v-model="searchData"></el-input>
                </el-form-item>
                <el-form-item class="distanceLeft">
                    <el-button type="primary" class="el-icon-search" @click.native="onSubmit()"></el-button>
                </el-form-item>
                <el-form-item label='筛选:' class="distanceLeft">
                    <template>
                        <el-checkbox-group v-model="checkList" @change="handleCheckedCitiesChange">
                            <el-checkbox label="药品状态正常"></el-checkbox>
                            <el-checkbox label="库存预警"></el-checkbox>
                        </el-checkbox-group>
                    </template>
                </el-form-item>

                <el-form-item class="distanceLeft">
                    <el-button type="primary" class="el-icon-download" @click.native="download()"></el-button>
                </el-form-item>

            </div>
        </el-form>

        <!--列表-->
        <el-table :data="addData" stripe style="width: 100%" :header-cell-style="tableHeaderColor">
            <el-table-column type="index" width="50"></el-table-column>
            <el-table-column prop="value" label="药品名称"></el-table-column>
            <el-table-column prop="medicineInpart" label="入药部分"></el-table-column>
            <el-table-column prop="manufacturer" label="产地"></el-table-column>
            <el-table-column sortable prop="retailPrice" label="零售价(￥)"></el-table-column>
            <el-table-column sortable prop="costPrice" label="成本价(￥)"></el-table-column>
            <el-table-column sortable prop="number" label="剩余数量"></el-table-column>
            <el-table-column sortable prop="recordNumber" label="预计余量"></el-table-column>
            <el-table-column sortable prop="inventoryWarning" label="预警数量"></el-table-column>
            <el-table-column prop="unit" label="单位"></el-table-column>
            <el-table-column label="操作" v-if="loginIdNumber === '622222222222222222'">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.status == 0" @click="handleClick(scope.row.id)" type="text" size="small">
                        停用
                    </el-button>
                    <el-button v-else-if="scope.row.status == -1" @click="startUsing(scope.row.id)" type="text"
                               size="small">启用
                    </el-button>
                    <el-button @click="compile(scope.row)" type="text"
                               size="small">编辑
                    </el-button>
                    <el-button @click="deleteMedicine(scope.row.id)" type="text"
                               size="small">删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 弹出框 -->
        <el-dialog title="编辑" :visible.sync="dialogTableVisible">
            <el-form :model="inventory" label-position='left'>
                <el-form-item label="药品名称:">
                    <el-input v-model="inventory.value"></el-input>
                </el-form-item>
                <el-form-item label="入药部分:">
                    <el-input v-model="inventory.medicineInpart"></el-input>
                </el-form-item>
                <el-form-item label="产地:">
                    <el-input v-model="inventory.manufacturer"></el-input>
                </el-form-item>
                <el-form-item label="零售价(￥):">
                    <el-input v-model="inventory.retailPrice"></el-input>
                </el-form-item>
                <el-form-item label="成本价(￥):">
                    <el-input v-model="inventory.costPrice"></el-input>
                </el-form-item>
                <el-form-item label="剩余数量:">
                    <el-input v-model="inventory.number"></el-input>
                </el-form-item>
                <el-form-item label="预计余量:">
                    <el-input v-model="inventory.recordNumber"></el-input>
                </el-form-item>
                <el-form-item label="预警数量:">
                    <el-input v-model="inventory.inventoryWarning"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogTableVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirm">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 分页 -->
        <div class="paging">
            <!--<div class="block">-->
            <!--<el-pagination :page-size="5" :total='total' small @current-change="handleCurrentChange"-->
            <!--:current-page.sync="currentPage" layout="total,prev, pager, next, jumper">-->
            <!--</el-pagination>-->
            <!--</div>-->
            <div class="block">
                <el-pagination
                        small
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page.sync=Current
                        :page-size=this.Size
                        layout="total,prev, pager, next, jumper"
                        :total=this.total>
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "nowStock",
        data() {
            return {
                dialogTableVisible: false,     // 编辑弹框
                addData: [],            //  展示 - 数据列表
                search: "",             //  搜索
                checkList: [],          //  筛选
                currentPage: 1,
                total: 0,
                Current: 1,
                Size: 10,
                searchData: '',          //  用户搜索数据
                drugState: false,        //  药品状态
                warning: false,          //  库存预警
                inventory: {
                    value: '',
                    manufacturer: '',
                    retailPrice: '',
                    costPrice: '',
                    number: '',
                    recordNumber: '',
                    inventoryWarning: '',
                    medicineInpart: ''           // 入药部分
                },
                rowId: '',
                downloadList: [], //下载清单列表
                loginIdNumber:''
            };
        },
        methods: {
            confirm() {                  //  确定
                let that = this;
                if (that.inventory) {
                    that.$axios({
                        url: "/api/medicines/" + that.rowId,
                        method: "PUT",
                        data: {
                            "costPrice": that.inventory.costPrice,
                            "inventoryWarning": that.inventory.inventoryWarning,
                            "manufacturer": that.inventory.manufacturer,
                            "number": that.inventory.number,
                            "recordNumber": that.inventory.recordNumber,
                            "retailPrice": that.inventory.retailPrice,
                            "value": that.inventory.value,
                            "unit": "g",
                            "medicineInpart": that.inventory.medicineInpart
                        }
                    }).then(res => {
                        if (res.data.code == 200) {
                            that.$message({
                                message: '修改成功',
                                type: 'success'
                            });
                            that.getMedicines();
                        } else {
                            that.$message({
                                message: '修改失败',
                                type: 'warning'
                            });
                        }
                        that.dialogTableVisible = false;
                    }).catch(err => {
                        console.log(err);
                    });
                }
            },
            compile(row) {
                let that = this;
                that.rowId = row.id;
                that.dialogTableVisible = true;
                that.inventory.value = row.value;
                that.inventory.manufacturer = row.manufacturer;
                that.inventory.retailPrice = row.retailPrice;
                that.inventory.costPrice = row.costPrice;
                that.inventory.number = row.number;
                that.inventory.recordNumber = row.recordNumber;
                that.inventory.medicineInpart = row.medicineInpart;
                that.inventory.inventoryWarning = row.inventoryWarning;
            },
            deleteMedicine(row) {
                let thId = row;
                if (thId) {
                    this.$axios({
                        url: "/api/medicines/" + thId,
                        method: "DELETE"
                    }).then(res => {
                        if (res.data.code == 200) {
                            this.getMedicines();
                            this.$message({
                                message: '删除成功',
                                type: 'warning'
                            });
                        } else {
                            this.$notify({
                                title: '警告',
                                message: '药品有使用，不能删除！',
                                type: 'warning'
                            });
                        }
                    }).catch(err => {
                        console.log(err);
                    });
                } else {
                    this.$notify({
                        title: '警告',
                        message: '无法获取数据，此功能禁用',
                        type: 'warning'
                    });
                }
            },
            tableHeaderColor({row, column, rowIndex, columnIndex}) {
                if (rowIndex === 0) {
                    return "background-color:#f2f2f2;color: #a4a7af;";
                }
            },

            handleCheckedCitiesChange(val) {
                if (val.length == 2) {
                    this.drugState = true;
                    this.warning = true;
                } else if (val.length == 1) {
                    let thVal = val[0];
                    if (thVal == '药品状态正常') {
                        this.drugState = true;
                        this.warning = false;
                    } else {
                        this.drugState = false;
                        this.warning = true;
                    }
                } else {
                    this.drugState = false;
                    this.warning = false;
                }
                this.getMedicines();
            },
            onSubmit() {                             // 点击搜索获取数据
                this.Current = 1;
                this.getMedicines();

            },
            handleSizeChange(val) {
                this.Size = val;
            },
            handleCurrentChange(val) {
                this.Current = val;
                this.getMedicines();
            },
            getMedicines() {                         //  获取药品数据
                this.$axios({
                    url: "/api/medicines/pageNumber/" + this.Current + "/size/" + this.Size,
                    method: "POST",
                    data: {
                        "medicineName": this.searchData,
                        "medicineStatus": this.drugState,
                        "warning": this.warning
                    }
                }).then(res => {
                    if (res.data.code == 200) {
                        this.addData = res.data.data.content;
                        this.total = res.data.data.totalElements;
                    } else {
                        this.$notify({
                            title: '警告',
                            message: '无法获取数据请联系管理员',
                            type: 'warning'
                        });
                    }
                }).catch(err => {
                    console.log(err);
                });
            },
            // 下载excel
            download() {
                this.$axios({
                    url: "/api/medicines/pageNumber/" + 1 + "/size/" + 10000,
                    method: "POST",
                    data: {
                        "medicineName": this.searchData,
                        "medicineStatus": this.drugState,
                        "warning": this.warning
                    }
                }).then(res => {
                    if (res.data.code == 200) {
                        this.downloadList = res.data.data.content;
//                  this.total = res.data.data.totalElements;
                        require.ensure([], () => {
                            const {export_json_to_excel} = require('../../vendor/Export2Excel.js');　　//引入文件　　　　　　
                            const tHeader = ['药品名称', '入药部分', '产地', '零售价（元）', '成本价（元）', '剩余数量', '预计余量', '预警数量', '单位']; //将对应的属性名转换成中文
                            // const tHeader = [];

                            const filterVal = ['value', 'medicineInpart', 'manufacturer', 'retailPrice', 'costPrice', 'number', 'recordNumber', 'inventoryWarning', 'unit'];//table表格中对应的属性名　　　　　 　　　
                            const list = this.downloadList;
                            const data = this.formatJson(filterVal, list);

                            var filename = '药品列表' + new Date().toLocaleDateString()
                            export_json_to_excel(tHeader, data, filename);
                        })


                    } else {
                        this.$notify({
                            title: '警告',
                            message: '无法获取数据请联系管理员',
                            type: 'warning'
                        });
                    }
                }).catch(err => {
                    console.log(err);
                });
            },

            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            newdrugs: function () {              //  跳转 新增药品页
                this.$router.push({path: "./newdrugs"});
            },
            handleClick(row) {                  //  停用
                let thId = row;
                if (thId) {
                    this.$axios({
                        url: "/api/medicines/stop/" + thId,
                        method: "DELETE"
                    }).then(res => {
                        if (res.data.code == 200) {
                            this.getMedicines();
                            this.$message({
                                message: '已停用',
                                type: 'warning'
                            });
                        } else {
                            this.$notify({
                                title: '警告',
                                message: '很抱歉，停用失败',
                                type: 'warning'
                            });
                        }
                    }).catch(err => {
                        console.log(err);
                    });
                } else {
                    this.$notify({
                        title: '警告',
                        message: '无法获取数据，此功能禁用',
                        type: 'warning'
                    });
                }
            },
            startUsing(row) {                    //  启用
                let thId = row;
                if (thId) {
                    this.$axios({
                        url: "/api/medicines/nonstop/" + thId,
                        method: "PUT"
                    }).then(res => {
                        if (res.data.code == 200) {
                            this.getMedicines();
                            this.$message({
                                message: '启用成功',
                                type: 'success'
                            });
                            this.getMedicines();
                        } else {
                            this.$notify({
                                title: '警告',
                                message: '很抱歉，启用失败',
                                type: 'warning'
                            });
                        }
                    }).catch(err => {
                        console.log(err);
                    });
                } else {
                    this.$notify({
                        title: '警告',
                        message: '无法获取数据，此功能禁用',
                        type: 'warning'
                    });
                }
            }
        },
        created() {
            this.loginIdNumber = localStorage.idNumber;
            this.getMedicines();
        }
    };
</script>

<style type="text/css" scoped>
    .el-button--primary {
        color: #fff;
        background-color: rgb(60, 110, 169);
        border-color: rgb(60, 110, 169);
    }

    .el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
        color: #fff;
        background-color: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
    }

    .el-button--primary:focus, .el-button--primary:hover {
        background: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
        color: #fff;
    }

    .block {
        margin-top: 20px;
        padding-left: 33%;
    }

    .container {
        width: 98%;
        margin-left: 18px;
        padding-bottom: 50px;
        background-color: white;
    }

    .distanceLeft {
        margin-right: 10px;
    }

    .paging {
        margin-top: 20px;
        padding-left: 10%;
    }
</style>



// WEBPACK FOOTER //
// nowStock.vue?5f89f880